import { HttpClient } from '../HttpClient';
/**
 * * Get Attendance Logs
 */

export const GetAttendanceLogs = async ({ DateFrom, DateTo, PageNumber = 1, RowsPerPage = 10 }) => {
  try {
    const { data } = await HttpClient.get('api/attendancelogs', {
      params: {
        DateFrom,
        DateTo,
        PageNumber,
        RowsPerPage,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
